export enum Configuration {
    RainServiceProviderId = 13,
    SimOnlySubCategoryId = 27,
    TokenLength = 400,
    Vumatel=1,  
    MetroFibreNetworx=2,  
    WaterfallAccessNetworks=3,  
    DarkFibreAfrica=4,  
    Octotel=5,  
    Frogfoot=6,  
    Openserve=7,  
    Mitsol=8,  
    SADigitalVillages=9,  
    LinkAfrica=10,  
    PoloFieldsEstateResidents=11,  
    Rain=13,  
    Balwin=14,  
    KikuyuEstateResidents=15,  
    HomeConnect=16,  
    MTN=17,  
    OpenFibre=18,  
    Netstream=19,  
    CenturyCityConnect=20,  
    WaterfallHills=21,  
    DNATel=22,  
    Boleng=23,  
    EvotelFibre=24,  
    BlitzFibre=25,  
    RiseTelecoms=26,  
    CelerityNetworks=27,  
    Vodacom=28,  
    Lightstruck=29,  
    LinkLayer=30,  
    MunyakaResidentialEstate=31,  
    TTConnect=32,  
    Fibrenet=33,  
    FibreSuburbs=34,  
    RouteNetworks=35,  
    ZoomFibre=36,  
    WaterfallView=37,  
    MFibre=38,  
    SteynCity=39,  
    ThinkSpeed=40,  
    NetstreamJacaranda=41,  
}

export function getDescription(input: number | string): string | number {
    debugger
    const enumMapping: Record<number, string> = Object.fromEntries(
        Object.entries(Configuration)
            .filter(([key, value]) => !isNaN(Number(value as any)))
            .map(([key, value]) => [value as number, key])
    );
 
    const reverseMapping: Record<string, number> = Object.fromEntries(
        Object.entries(enumMapping).map(([key, value]) => [value.toLowerCase(), Number(key)])
    );
 
    if (typeof input === 'number') {
        return enumMapping[input] || "Unknown ID";
    } else {
        const inputLower = input.toLowerCase();
 
        // Exact match first
        if (reverseMapping[inputLower] !== undefined) {
            return reverseMapping[inputLower];
        }
 
        const sanitizedInput = inputLower.replace(/\s+/g, ""); // Remove all spaces
        const matchedKey = Object.keys(reverseMapping).find(key => key.replace(/\s+/g, "").includes(sanitizedInput));
        return matchedKey ? reverseMapping[matchedKey] : -1;
       
    }
}